import React, { useCallback, useEffect } from "react";
import {
  StyleSheet,
  View,
  StyleProp,
  ViewStyle,
  Image,
  ImageSourcePropType,
  Text,
  TouchableOpacity,
  ActivityIndicator,
} from "react-native";
import { colors } from "src/assets";
import { navigationRef } from "src/hooks/navigation";
import { EventRegister } from "react-native-event-listeners";

export type HeaderProps = {
  style?: StyleProp<ViewStyle>;
  imageSource?: ImageSourcePropType;
  name?: string;
  email?: string;
  loading?: boolean;
  onChangeImage?: (image?: string) => void;
};

export const Header: React.FC<HeaderProps> = ({
  style,
  imageSource,
  name,
  email,
  onChangeImage,
  loading,
}) => {
  useEffect(() => {
    const listener = EventRegister.addEventListener("MyPageImageEvent", (e) => {
      if (onChangeImage) {
        onChangeImage(e.dataURL);
      }
    });
    return () => {
      EventRegister.removeEventListener(listener as string);
    };
  }, [onChangeImage]);

  const onImageUpload = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target?.files?.[0]) {
        navigationRef.current?.navigate("CustomImageCrop", {
          eventName: "MyPageImageEvent",
          file: event.target?.files?.[0],
          aspect: 1,
          // maxSize: {
          //   width: 200,
          //   height: 200,
          // },
        });
      }
      event.target.value = "";
    },
    []
  );
  return (
    <View style={[styles.container, style]}>
      <input
        id="image-upload"
        type="file"
        onChange={onImageUpload}
        accept="image/*"
        style={{ display: "none" }}
      />
      {imageSource ? (
        <label htmlFor="image-upload">
          <TouchableOpacity>
            <Image source={imageSource} style={styles.avatar} />
            {loading ? (
              <View style={styles.loading}>
                <ActivityIndicator color={colors.white} />
              </View>
            ) : null}
          </TouchableOpacity>
        </label>
      ) : (
        <label htmlFor="image-upload">
          <TouchableOpacity style={[styles.avatar, styles.avatarEmpty]}>
            <svg width="22.174" height="17.798" viewBox="0 0 22.174 17.798">
              <path
                d="M2.735,17.8A2.738,2.738,0,0,1,0,15.063V5.35A2.738,2.738,0,0,1,2.735,2.615H5.568c.183-.266.378-.588.556-.881A8.2,8.2,0,0,1,6.693.867C7.416,0,8.131,0,9.556,0h3.061c1.425,0,2.14,0,2.863.867a8.209,8.209,0,0,1,.568.867c.178.293.374.615.557.881h2.832A2.738,2.738,0,0,1,22.174,5.35v9.713A2.738,2.738,0,0,1,19.438,17.8ZM1.563,5.35v9.713a1.174,1.174,0,0,0,1.172,1.172h16.7a1.174,1.174,0,0,0,1.172-1.172V5.35a1.173,1.173,0,0,0-1.172-1.172H16.211a.782.782,0,0,1-.609-.292,13.3,13.3,0,0,1-.887-1.34c-.158-.259-.354-.582-.434-.678-.225-.27-.254-.305-1.662-.305H9.556c-1.409,0-1.437.035-1.662.305-.08.1-.277.419-.434.678a13.229,13.229,0,0,1-.888,1.34.781.781,0,0,1-.609.292H2.735A1.173,1.173,0,0,0,1.563,5.35ZM6.105,9.678a4.982,4.982,0,1,1,4.981,4.981A4.987,4.987,0,0,1,6.105,9.678Zm1.563,0a3.419,3.419,0,1,0,3.419-3.419A3.423,3.423,0,0,0,7.668,9.678Zm8.361-3.689a.814.814,0,1,1,.814.814A.814.814,0,0,1,16.029,5.988Z"
                fill="#b2b2b2"
              />
            </svg>
            {loading ? (
              <View style={styles.loading}>
                <ActivityIndicator color={colors.white} />
              </View>
            ) : null}
          </TouchableOpacity>
        </label>
      )}
      <View style={styles.content}>
        {name ? <Text style={styles.name}>{name}さん</Text> : null}
        {email ? <Text style={styles.email}>{email}</Text> : null}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    backgroundColor: colors.white,
    padding: 16,
  },
  avatar: {
    width: 80,
    height: 80,
    borderRadius: 40,
  },
  avatarEmpty: {
    backgroundColor: colors.gray1,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    marginLeft: 24,
  },
  name: {
    fontSize: 15,
    fontWeight: "600",
    color: colors.chokuBlack,
  },
  email: {
    marginTop: 4,
    fontSize: 12,
    fontWeight: "600",
    color: colors.chokuGray,
  },
  loading: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
});
